<template>
    <v-simple-table
        v-if="shippingChargedProducts.length > 0"
        dense
        class="totals-table--bordered"
    >
        <thead>
            <tr>
                <th class="totals-th--bordered">
                    <TranslatableStringComponent :tstring="{string: 'oversizedPackageShipping'}" />
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="totals-td--bordered">
                    <div v-if="fetchShippingCharges > 0">
                        <div class="mb-4">
                            <span>{{ dollars(fetchShippingCharges) }}</span>
                        </div>

                        <p style="font-size: 12px">
                            <fa
                                :icon="['fal', 'info-circle']"
                                v-bind="attrs"
                                class="fa-lg mr-2"
                                style="color: #0063a6"
                            />
                            <span>
                                <TranslatableStringComponent :tstring="{string: 'checkoutNoticeForWireDuctShippingCharges'}" />
                            </span>
                        </p>
                    </div>
                    <div
                        v-else-if="selectedCarrierMethod === 'billToMyCarrier'"
                    >
                        <p style="font-size: 12px">
                            <fa
                                :icon="['fal', 'info-circle']"
                                v-bind="attrs"
                                class="fa-lg mr-2"
                                style="color: #0063a6"
                            />
                            <span>
                                <TranslatableStringComponent :tstring="{string: 'expediteShippingPackage'}" />
                            </span>
                        </p>
                    </div>
                    <div v-else>
                        <p style="font-size: 12px">
                            <fa
                                :icon="['fal', 'info-circle']"
                                v-bind="attrs"
                                class="fa-lg mr-2"
                                style="color: #0063a6"
                            />
                            <span>
                                <TranslatableStringComponent :tstring="{string: 'oversizedPackageShippingPlaceholderMessage'}" />
                            </span>
                        </p>
                    </div>
                </td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'OversizedPackageShippingSection',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return { attrs: null }
    },
    computed: {
        ...mapGetters({
            fetchShippingCharges: 'cart/fetchShippingCharges',
            shippingChargedProducts: 'cart/shippingChargedProducts',
        }),
        ...mapState('cart', ['selectedCarrierMethod']),
    },
}
</script>

<style></style>
